// extracted by mini-css-extract-plugin
module.exports = {"menuBg":"#253546","menuText":"#bfcbd9","menuActiveText":"#bfcbd9","theme":"#1890ff"};